import type { ComponentType } from "react";
import { createDuplicateStore, DuplicateContext } from "feat/guest/state/duplicate.context";
import { routes } from "routing";
import { lazyView, type RouteRender } from "routing/tree";
import i18n from "i18n/i18next";

const { guestDuplicate } = routes;

// One store shared across the flow: each page is an independent sibling <Route>,
// so a provider created per page would give each page its own isolated store and
// lose the org/itinerary/range selections made on earlier pages.
const duplicateStore = createDuplicateStore();

const withDuplicateContext = (Inner: ComponentType) => {
  return function DuplicateContextWrapper() {
    return (
      <DuplicateContext.Provider value={duplicateStore}>
        <Inner />
      </DuplicateContext.Provider>
    );
  };
};

export const guestDuplicateRoutes: RouteRender[] = [
  lazyView(
    guestDuplicate.team,
    () =>
      import("./team/guest-duplicate-team").then((m) => ({ default: withDuplicateContext(m.GuestDuplicateTeamPage) })),
    () => i18n.t("guest.duplicateItinerary"),
  ),
  lazyView(
    guestDuplicate.itinerary,
    () =>
      import("./itinerary/guest-duplicate-itinerary").then((m) => ({
        default: withDuplicateContext(m.GuestDuplicateItineraryPage),
      })),
    () => i18n.t("guest.duplicateItinerary"),
  ),
  lazyView(
    guestDuplicate.dates,
    () =>
      import("./dates/guest-duplicate-dates").then((m) => ({
        default: withDuplicateContext(m.GuestDuplicateDatesPage),
      })),
    () => i18n.t("guest.duplicateItinerary"),
  ),
];
